import { Box } from "@mui/material";
import BASelect from './BASelect'
import { useState } from "react";
import BAInput from "./BAInput";
import BAButton from "./BAButton";
import BAIconbutton from "./BAIconbutton";
import SearchIcon from '@mui/icons-material/Search';
import BAModal from "./BAModal";

export default function BASearchBar(props) {
    const { datasourse, onSearch } = props
    const [searchBy, setSearchBy] = useState()
    const [searchVal, setSearchVal] = useState()
    const [searchModal, setSearchModal] = useState(false)

    const searchClick = () => {
        onSearch(searchBy, searchVal)
    }
    return <>
        <Box className="webView">
            <Box className="border d-flex rounded ps-3 justify-content-center align-items-center">
                <Box>
                    <BASelect value={searchBy} onChange={(e) => setSearchBy(e.target.value)} valueField='key' displayField="value" datasource={datasourse} />
                </Box>
                <Box className="ms-2">
                    <BAInput value={searchVal} onChange={(e) => setSearchVal(e.target.value)} />
                </Box>
                <Box>
                    <BAIconbutton variant="outlined" icon={<SearchIcon />} onClick={searchClick} label='Search' />
                </Box>
            </Box>
        </Box>
        <Box className="mobileView">
            <BAIconbutton variant="outlined" icon={<SearchIcon />} onClick={() => setSearchModal(true)} label='Search' />
            <BAModal width="70vw" open={searchModal} close={(e) => setSearchModal(e)} modalTitle="Search" innerContent={<Box>
                <Box className="py-2">
                    <BASelect value={searchBy} onChange={(e) => setSearchBy(e.target.value)} valueField='key' displayField="value" datasource={datasourse} />
                </Box>
                <Box className="py-2">
                    <BAInput label='Search' value={searchVal} onChange={(e) => setSearchVal(e.target.value)} />
                </Box>

            </Box>} modalFooter={<Box>
                <BAButton startIcon={<SearchIcon />} fullWidth={true} onClick={() => {
                    setSearchModal(false)
                    searchClick()
                }} label='Search' />
            </Box>} />
        </Box>
    </>
}